const uuidv4 = require('uuid/v4');
const InputMasks = require('../helpers/inputMasks');

const divPoliticaIntervalos = document.querySelector('[data-politica-km-intervalo]');
const inputTemplate = document.querySelector('[data-politica-km-input-template]');
const btnAddIntervalo = document.querySelector('[data-politica-km-add-intervalo]');
const btnsRemoveIntervalo = document.querySelectorAll('[data-politica-km-remove-intervalo]');
const rowsIntervalo = document.querySelectorAll('[data-politica-km-intervalo-row]:not([data-politica-km-input-template])');

function PoliticaKm() {
  if (!divPoliticaIntervalos) {
    return;
  }

  if (btnAddIntervalo) {
    btnAddIntervalo.addEventListener('click', handleAddIntervalo);
  }

  if (btnsRemoveIntervalo.length) {
    btnsRemoveIntervalo.forEach(btn => {
      btn.addEventListener('click', handleRemoveIntervalo);
    });
  }

  // Se por acaso não tiver nenhuma row de intervalo na pagina, adiciona uma.
  // **pode conter caso ja exista intervalos cadastrados para editar**
  if (!rowsIntervalo.length) {
    handleAddIntervalo();
  }
};

/**
 * Adiciona uma nova linha de intervalo para a politica
 */
function handleAddIntervalo() {
  const cloneInputTemplate = inputTemplate.cloneNode(true);

  cloneInputTemplate.classList.remove('hidden');
  cloneInputTemplate.removeAttribute('data-politica-km-input-template')

  // Registra evento para remover input
  cloneInputTemplate
    .querySelector('[data-politica-km-remove-intervalo]')
    .addEventListener('click', handleRemoveIntervalo);

  // Adiciona um uuid4 no nome do input para ligar os inputs de valor e km
  const uuid = uuidv4();
  cloneInputTemplate.querySelectorAll('[name^=intervalos]').forEach(item => {
    item.name = item.name.replace('id', uuid);
    item.id = item.name;
  });

  inputTemplate.parentNode.appendChild(cloneInputTemplate);

  InputMasks.init();
}

/**
 * Remove uma linha de input intervalo da politica
 * @param  Event event
 */
function handleRemoveIntervalo(event) {
  event.target.closest('[data-politica-km-intervalo-row]').remove();
}

module.exports = {
  init: PoliticaKm,
  url: /limites-de-percurso/
};
